import { Component, Input, Output, EventEmitter, inject, HostListener } from '@angular/core';
import { ImageViewerService } from '../../services/image-viewer.service';

@Component({
  selector: 'image-viewer',
  templateUrl: './image-viewer.component.html'
})
export class ImageViewerComponent {

  private imageViewerService = inject(ImageViewerService);

  visible = this.imageViewerService.visible;
  imageUrl = this.imageViewerService.imageUrl;

  onClose() {
    this.imageViewerService.close();
  }

  @HostListener('document:keydown.escape', ['$event'])
  onEsc() {
    if (this.visible()) {
      this.onClose();
    }
  }
}

